export default "__VITE_ASSET__CQ8J$q03__"